import React, { Fragment, useEffect, useState, useMemo } from 'react'
import useStyles from './styles'
import BidList from './BidList'
import ChatList from './ChatList'
import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core'
import ArrowBackwardIcon from '@material-ui/icons/ArrowBack'
import PurchaseList from './PurchaseList'
import { useDispatch, useSelector } from 'react-redux'
import { HeaderImage } from 'components/ItemDetails/Image'
import AmountBanner from './AmountBanner'
import ChatBar from './ChatBar'
import { openDialog } from 'actions/dialogs'
import classnames from 'clsx'
import { isEmpty } from 'lodash'
import { getEventDonations } from 'actions/event'
import DonationsList from './DonationsList'

const EngagementsBoard = ({ item, donateMode }) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const orientation = useSelector(state => state.window.orientation)

  const event = useSelector(state => state.event.event)
  const donations = useSelector(state => state.event.donations)
  const liveSettings = event.live_settings

  const [donationsLoaded, setDonationsLoaded] = useState(false)
  let trying = false

  const openItemDialog = () => {
    dispatch(openDialog('item', item))
  }

  const donationsAmount = useMemo(() => {
    return donations.map(d => d.donation_amt).reduce((a, b) => a + b, 0)
  }, [donations])

  return (
    <Box
      display="flex"
      height="100%"
      flexDirection="column"
      className={classnames(classes.engagementsBoard, classes[orientation])}
    >
      {donateMode && (
        <Box className={classes.donateBox}>
          <Box
            flexGrow={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography className={classes.donateNowText} variant="h2">
              Donate Now!
            </Typography>
          </Box>
          {donationsAmount > 0 && (
            <Box className={classes.donationAmountBanner}>
              <AmountBanner
                item={item}
                donationAmount={donationsAmount}
                donateMode={donateMode}
              />
            </Box>
          )}
        </Box>
      )}
      {!donateMode && !isEmpty(item) && (
        <Fragment>
          <Box className={classes.imageBox}>
            <Box className={classes.itemContent}>
              <Box className={classes.typography} marginBottom={1}>
                <Typography className={classes.liveNowText} variant="h2">
                  Live Now!
                </Typography>
                <Typography
                  className={classes.itemTitleTypography}
                  variant="h2"
                >
                  {item.name}
                </Typography>
              </Box>
              <Button
                id="fullDetailsButtonOne"
                variant="contained"
                className={classes.detailsButton}
                onClick={openItemDialog}
              >
                View full details
              </Button>
            </Box>
            <Box className={classes.imageOverlay} />
            <HeaderImage
              image={item.image[0]}
              className={classes.headerImage}
            />
          </Box>
          <AmountBanner item={item} donateMode={donateMode} />
        </Fragment>
      )}
      <Box className={classes.engagementsListWrapper}>
        {liveSettings.show_chat && <ChatList item={item} />}
        {!liveSettings.show_chat && (
          <Fragment>
            {!donateMode && (
              <Fragment>
                {item.item_type === 'auction' && <BidList item={item} />}
                {item.item_type === 'fixed' && <PurchaseList item={item} />}
              </Fragment>
            )}
            {donateMode && <DonationsList />}
          </Fragment>
        )}
      </Box>
      {liveSettings.show_chat && <ChatBar />}
    </Box>
  )
}

export default EngagementsBoard



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/index.jsx